import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);

type BizApiResponse<T> = {
  code: number;
  msg: string;
  data: T;
};

export const createBizRequest = () => {
  const request = createAppRequest();
  return async <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const response = await request<BizApiResponse<T> | T>(url, options);
    if (
      response &&
      typeof response === 'object' &&
      'code' in response &&
      'data' in response
    ) {
      return (response as BizApiResponse<T>).data;
    }
    return response as T;
  };
};
